import {StatusModel} from './status.model';
import {forwardingTargets, forwardingTypes} from './status.constants';

export class StatusAvailableModel extends StatusModel {
  forwardingType: number;
  forwardingTarget: number;
  forwardingDelay: number;

  getForwardingText(): string {
    if (this.forwardingType === 9) {
      return forwardingTypes.find(t => t.key === 9).text;
    }
    const target = forwardingTargets.find(t => t.key === this.forwardingTarget);
    if (target) {
      return target.text;
    } else {
      return '';
    }
  }

  getForwardingDelay(): number {
    return this.forwardingDelay;
  }
}
